module.exports = __webpack_public_path__ + "static/media/IMG_1635.ecef19ec.JPG";